import React from 'react'

import { BodyText } from '@pb/components'
import { formatCurrency, formatDate } from '@pb/utils'

export const ITEM_TYPE = {
  AMOUNT: 'AMOUNT',
  DATE: 'DATE',
  TEXT: 'TEXT',
}

const SummaryItem: React.FC<any> = ({ label, value, type = ITEM_TYPE.TEXT }) => (
  <tr>
    <BodyText Tag="th">{label}</BodyText>
    <BodyText Tag="td" right>
      {type === ITEM_TYPE.AMOUNT
        ? formatCurrency(value / 100)
        : type === ITEM_TYPE.DATE
        ? formatDate(value)
        : value}
    </BodyText>
  </tr>
)

export default SummaryItem
